<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf p-t-15">
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'></a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange"  :show-total="total => `总数:${total} `"/>
    </div>
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getAgentList } from "@/api/agent";
  import { iscode } from "@/utils/app";
  import {getSynchroRecord} from '@/api/public_wx.js'
  let defSearch = {
    page: 1,
    limit: 10,
  };
  export default {
    cardList: 'syncList',
    components: {  },
    setup(props, ctx) {
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 1,
        labelCol: { span: 4 },
        wrapperCol: { span: 16 }
      });
      let columns = [
        {
          title: "同步时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "类型",
          dataIndex: "type_name",
          key: "type_name",
        },
        {
          title: "同步数量",
          dataIndex: "num",
          key: "num",
        },
        {
          title: "成功同步",
          dataIndex: "success_num",
          key: "success_num",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
        },
      ];
      const $router = inject('$router')
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getSynchroRecord(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
      };
    },
  };
</script>